import React from 'react';

import Icon from '../Icon/Icon';

const RestartDeviceBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g fill='none' fillRule='evenodd'>
                <path
                    d='m20.006 9.555 1.046-.488a2.154 2.154 0 0 1 2.863 1.042l7.468 16.014a1 1 0 0 1-.484 1.33l-2.092.975a1 1 0 0 1-1.329-.484l-7.955-17.06a1 1 0 0 1 .483-1.33z'
                    fill='#00D1D2'
                />
                <path
                    d='M28.956 40.027a4.486 4.486 0 0 1-3.441.15 4.486 4.486 0 0 1-2.54-2.326l-9.918-21.27a4.486 4.486 0 0 1-.15-3.44 4.486 4.486 0 0 1 2.327-2.54l1.967-.917a6.65 6.65 0 0 1 5.1-.223 6.65 6.65 0 0 1 3.765 3.45l9.212 19.755a3.987 3.987 0 0 1 .133 3.058 3.987 3.987 0 0 1-2.068 2.257z'
                    stroke='#34303D'
                    strokeWidth='2'
                />
                <path
                    d='M32.704 38.436a2.154 2.154 0 0 1-1.858-1.242L19.01 11.813a2.154 2.154 0 0 1 1.042-2.863'
                    stroke='#34303D'
                    strokeWidth='2'
                />
                <path stroke='#34303D' strokeWidth='2' strokeLinecap='square' d='m28.278 28.374 3.905-1.821' />
                <path
                    d='M8.63 17.474a16.83 16.83 0 0 0 .3 13.583 16.819 16.819 0 0 0 9.222 8.613m21.373-8.63a16.839 16.839 0 0 0-.008-14.246A16.834 16.834 0 0 0 29.04 7.752'
                    stroke='#34303D'
                    strokeWidth='2'
                    strokeLinecap='round'
                />
                <path
                    stroke='#34303D'
                    strokeWidth='2'
                    strokeLinecap='round'
                    d='m16.926 36.188 1.569 3.364-3.365 1.569M30.217 11.088l-1.57-3.364 3.365-1.57'
                />
            </g>
        </Icon>
    );
};

export default RestartDeviceBlueIcon;
